import { Color } from 'three';

import glslRectSDF from '@resn/gozer-glsl/sdf/sdRect.glsl';

import glslCircle from '@/libs/lygia/draw/circle.glsl';
import glslScale from '@/libs/lygia/space/scale.glsl';

export const shaderChunks = {
    uniforms: () => ({
        uPreRevealColor1: { value: new Color() },
        uPreRevealColor2: { value: new Color() },

        uHeartbeatPr: { value: 0 },

        uTexPreRevealSticker: { value: null },

        uPreRevealStickerAspect: { value: 1 },
    }),
    funcs: /* glsl */ `
        uniform vec3 uPreRevealColor1;
        uniform vec3 uPreRevealColor2;
        
        uniform float uHeartbeatPr;
        uniform float uPreRevealStickerAspect;
        
        uniform sampler2D uTexPreRevealSticker;

        ${glslCircle}
        ${glslScale}
        ${glslRectSDF}

        float createCircle(vec2 uv, float angle, float dist, float radius, float thickness) {
            uv -= 0.5;
            uv.y *= 1.8;
            uv.x += sin(angle) * dist;
            uv.y += cos(angle) * dist;
            uv += 0.5;
            float circleShape = fill(circleSDF(uv), radius, thickness);
            
            return circleShape;
        }

        vec4 getColorSticker(vec2 vUv, vec2 objectAspect, float uStickerScale, sampler2D tSticker) {
            vec2 stickerAspect = vec2(1.0, uPreRevealStickerAspect);
            vec2 uvSticker = scale(vUv, objectAspect * stickerAspect * uStickerScale);
            vec4 preRevealSticker = texture2D(tSticker, uvSticker);
            return preRevealSticker;
        }

        vec3 preReveal(vec2 uv, float outlineScaleIn, sampler2D tSticker, float uStickerScale, float uTime, bool useSticker) {
            vec2 circleUv = uv - 0.5;
            circleUv.y *= 1.8;

            vec2 outlineUv = scale(uv, vec2(0.9));
            vec2 outlineScale = vec2(0.98, 1.0) * outlineScaleIn;
            float outline = 1.0 - fill(sdRect(outlineUv, outlineScale, -0.95), 1.0);
            // outline = mix(0.2, 1.0, outline);
            
            vec2 objectAspect = vec2(1.0, 1.76);
            vec4 cSticker = useSticker ? getColorSticker(uv, objectAspect, uStickerScale, tSticker) : vec4(0.0);

            float dist = mix(0.8, 0.7, uHeartbeatPr);
            float radius = mix(0.7, 1.5, uHeartbeatPr);
            float thickness = 0.5;
            float circle1 = createCircle(uv, uTime, dist, radius, thickness);
            float circle2 = createCircle(uv, uTime + PI, dist, radius, thickness);
            float circle3 = createCircle(uv, uTime * 1.2, dist, radius, thickness);
            float circle = circle1 + circle2 + circle3 * 0.2;
            vec3 circleColor = circle1 * 3.0 * uPreRevealColor1 + circle2 * 3.0 * uPreRevealColor2 + circle3 * uPreRevealColor1 * 0.2;
            
            vec3 cPreReveal = vec3(outline) * circleColor;
            cPreReveal = mix(cPreReveal, cSticker.rgb, cSticker.a);
            cPreReveal += circleColor * mix(0.002, 0.004, uHeartbeatPr);

            return cPreReveal;
        }

        vec3 preReveal(vec2 vUv, float outlineScaleIn, sampler2D tSticker, float uTime, bool useSticker) {
            return preReveal(vUv, outlineScaleIn, tSticker, 3.0, uTime, useSticker);
        }
    `,
};
